import { useContext, useEffect } from "react";
import { PageContext } from "../Context/PageContext";
import styled from "styled-components";
import { BrowserRouter, useLocation } from 'react-router-dom';
import Home from "./Home/Home";
import Downloads from "./Download/Download";
import Rankings from "./Ranking/Rankings";
import Guias from "./Guias/Guias";
import Cadastro from "./Cadastro/Cadastro";
import Database from "./Database/Database";
import Dashboard from "./Dashboard/Dashboard";
import UserNotLogged from "./Dashboard/DashboardItems/UserNotLogged";


function ContentArea() {

    const location = useLocation();
    const {page, setPage, isLogged} = useContext(PageContext);

    useEffect(() => {
    // A cada mudança de URL (location.pathname), o estado é atualizado
    const pathname = location.pathname;
    
    if (pathname === '/') {
      setPage(<Home/>);
    } else if (pathname === '/Downloads') {
       setPage(<Downloads/>);
    } else if (pathname === '/Rankings'){
      setPage(<Rankings/>);
    } else if (pathname === '/Guias'){
      setPage(<Guias/>);
    //} else if (pathname === '/Cadastro'){
    //  setPage(<Cadastro/>);
    } else if (pathname === '/Database'){
      setPage(<Database/>);
    } else if (pathname === '/Conta'){
      setPage(<Dashboard/>);
    }

  }, [location.pathname]); // O useEffect roda sempre que a URL muda

    
    return(
        <Master>{page}</Master>
    );

};


export default ContentArea;

const Master = styled.div`
    margin: 0;
    padding: 0;
    margin-bottom: 100px;

`